import Topbar from "../components/Topbar";
import { useState, useEffect } from "react";
import ExplorePageExtLink from "../components/ExplorePageExtLink";
import axios from "axios";

// Styling
import "../css/ExplorePage.css";
import useCurrentUser from "../hooks/useCurrentUser";

const Explore = () => {
    // Expeditions enum
    const Expeditions = Object.freeze({
        NONE: 0,
        COMPUTERBUILDING: 1,
        DIGITALART: 2,
        ALGORITHMICART: 3,
        AIART: 4
    });

    const pixelArt = {
        name: "PIXEL ART",
        urlSlug: "/pixel-art", // TODO: Create component at this route
        description: "Create stunning pixel art pieces!"
    }

    const algorithmicArt = {
        name: "ALGORITHMIC ART",
        urlSlug: "/algorithmic-art", // TODO: Create component at this route
        description: "Program a Digital Brush to make beautiful drawings!"
    }

    const aiArt = {
        name: "AI ART",
        urlSlug: "/ai-art", // TODO: Create component at this route
        description: "Craft prompts to generate new artwork with Stable Diffusion!"
    }

    let expeditionObjects = [pixelArt, algorithmicArt, aiArt];

    const [selectedExpedition, setSelectedExpedition] = useState(null);

    let selectedExpeditionPanel;

    useEffect(() => {
        selectedExpeditionPanel = document.getElementById("selected-expedition");
        let selectedExpeditionPanelBG = document.getElementById("selected-expedition-bg");
        // If selectedExpedition == NONE, do not display selected expedition panel
        // Otherwise, display the panel for the selected expedition
        if (selectedExpeditionPanel) {
            if (selectedExpedition == null) {
                selectedExpeditionPanel.style.visibility = "hidden";
            } else {
                selectedExpeditionPanel.style.visibility = "visible";

                // Change background image of selected expedition panel
                // to give a sneak-peak for the digital experience user is about to launch
                if (selectedExpedition.name == pixelArt.name) {
                    selectedExpeditionPanelBG.classList.add("selected-pixel");
                    selectedExpeditionPanelBG.classList.remove("selected-algorithmic");
                    selectedExpeditionPanelBG.classList.remove("selected-ai");
                } else if (selectedExpedition.name == algorithmicArt.name) {
                    selectedExpeditionPanelBG.classList.add("selected-algorithmic");
                    selectedExpeditionPanelBG.classList.remove("selected-pixel");
                    selectedExpeditionPanelBG.classList.remove("selected-ai");
                } else if (selectedExpedition.name == aiArt.name) {
                    selectedExpeditionPanelBG.classList.add("selected-ai");
                    selectedExpeditionPanelBG.classList.remove("selected-pixel");
                    selectedExpeditionPanelBG.classList.remove("selected-algorithmic");
                }
            }
        }        
    }, [selectedExpedition]);

    const user = useCurrentUser();

    // If user is a student, set this to user's student object
    // Otherwise keep this object = null
    const [studentUser, setStudentUser] = useState(null);

    // Check to see if user is a student; if so, set variable studentUser
    useEffect(() => {
        if (user) {
            // If user is a student...
            if (!user.is_staff && !user.is_superuser) {
                console.log(`${user.email} is a student user.`)
                axios.get(`/api/students/${user.id}`)
                    .then(response => {
                        setStudentUser(response.data);
                    })
            }
        }
    }, [user]);

    // Link to survey dashboard login - to show on teachers' interface
    const teacherSurveyDashboardLink = "https://26.selectsurvey.net/empiricaleducation/Login.aspx";

    function clickExpedition(e) {
        if (!e.target.classList.contains("selected-expedition")) {
            // Get the object that corresponds to the panel that was clicked
            let text = e.target.textContent;
            expeditionObjects.forEach(expeditionObject => {
                if (text == expeditionObject.name) {
                    setSelectedExpedition(expeditionObject);
                }
            })

            // Remove .selected-expedition class styling from all expedition panels
            let expeditionPanels = document.getElementById("digital-expeditions");
            for (const expeditionPanel of expeditionPanels.children) {
                expeditionPanel.classList.remove("selected-expedition");
            }

            // Add .selected-expedition class styling to this panel
            e.target.classList.add("selected-expedition");          
        } else {
            setSelectedExpedition(null);
            selectedExpeditionPanel.style.visibility = "hidden";
            e.target.classList.remove("selected-expedition");
        }
    }

    return (
        <div id = "explore-page" className = "page">
            <Topbar isExplorePage = {true} />
            <div id = "explore-page-content">
                <div id = "static-content">
                    <div id = "explore-header">
                        <h1>Explore the FRACTAL Digital Studios...</h1>
                        <h5>Click on a <strong>Studio</strong> below to launch!</h5>
                    </div>
                    <div id = "digital-expeditions">
                        <div id = "pixel-art" className = "disallow-text-select" onClick={clickExpedition}>PIXEL ART</div>
                        <div id = "algorithmic-art" className = "disallow-text-select" onClick={clickExpedition}>ALGORITHMIC ART</div>
                        <div id = "ai-art" className = "disallow-text-select" onClick={clickExpedition}>AI ART</div>
                    </div>
                    {/* If user is a student, show pre and post survey links (if applicable). */}
                    {(user && 
                        studentUser && 
                        studentUser.pre_survey_link && 
                        studentUser.post_survey_link
                    ) ? (
                        <>
                            <ExplorePageExtLink 
                                link={studentUser.pre_survey_link}
                                text={"Take student pre-survey"}/>
                            <ExplorePageExtLink
                                link={studentUser.post_survey_link}
                                text={"Take student post-survey"}/>
                        </>
                    // If a user is a teacher, link to survey dashboard login
                    ) : (user && !user.is_superuser && user.is_staff && (
                        <ExplorePageExtLink 
                            link={teacherSurveyDashboardLink}
                            text={"Launch Teacher Survey Dashboard."}/>
                    ))}
                    {/* <div id = "faq">
                        <h2>Need Help?</h2>
                        <div id = "faq-content">
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum. <br /><br />
                                
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum. <br /><br />

                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum. <br /><br />

                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum. <br /><br />

                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum. <br /><br />

                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum. <br /><br />

                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum. <br /><br />

                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum. <br /><br />

                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa 
                                qui officia deserunt mollit anim id est laborum.
                            </p>
                        </div>
                    </div> */}
                </div>
                {selectedExpedition !== null ? (
                    <div id = "selected-expedition-bg">
                        <div id= "selected-expedition">
                            <h3 className = "disallow-text-select">{selectedExpedition["name"]}</h3>
                            <h4 className = "disallow-text-select">{selectedExpedition["description"]}</h4>
                            <a href={selectedExpedition["urlSlug"]}><button id = "launch-button">LAUNCH</button></a>
                        </div>
                    </div>
                ) : null}            
            </div>            
        </div>
    );
};

export default Explore;